export const EVENTS_CHANNEL = 'pre_order_form:events';
